import { lengthContraction } from '@/domain/physics/SpecialRelativity.js'
import BlockElement from '@/domain/scene/generic/BlockElement.js'

const INDICATOR_BLOCK_COLOR = 'rgb(70, 70, 70)'
const CORNER_RADIUS_REL = 0.0035
const FONT_SIZE_REL = 0.0075

export default class IndicatorBlock extends BlockElement {
  constructor (name, widthRel, heightRel, initXRel, initYRel) {
    super(
      name,
      widthRel,
      heightRel,
      initXRel,
      initYRel,
      INDICATOR_BLOCK_COLOR
    )
  }

  setOnScene (sceneWidth, sceneHeight, speedC = null, text = '') {
    this.width = sceneWidth * this.widthRel

    if (this.heightRel !== null) {
      this.height = sceneHeight * this.heightRel
    } else {
      this.height = this.width
    }

    let initXRel = this.initXRel
    if (speedC !== null) {
      initXRel = lengthContraction(this.initXRel, speedC)
    }

    this.x = (sceneWidth * initXRel) - (this.width / 2)
    this.y = (sceneHeight * this.initYRel) - (this.height / 2)

    this.halfWidth = this.width / 2
    this.halfHeight = this.height / 2

    this.radiusValue = parseInt(sceneWidth * CORNER_RADIUS_REL)

    this.fontSize = sceneWidth * FONT_SIZE_REL
    this.text = text
  }

  getConfig () {
    let result = super.getConfig()

    result.cornerRadius = this.radiusValue
    return result
  }
}
